/*****
 * Created with WebStorm.
 * Date : 2019/5/31.
 * Author : Ztr.
 * Func : ....
 * note : 医生端
 ******/
import $https from '@/utils/https'

// 测试
export function getDemoList (params) {
  return $https({
    
  })
}


// WEBPACK FOOTER //
// ./src/services/modules/doctor.js